import { useEffect, useState } from "react";
import { useLocation, useNavigate, useOutletContext } from "react-router-dom";

import { Heading } from "V2.0/common/heading";
import usePipelinesV2 from "./usePipelinesV2";
import PipelineCreateV2 from "./PipelineV2Create";
import PipelineList from "../Pipelines/PipelineList";
import PipelineBuilderV2 from "./PipelineBuilderV2";

export default PipelinesV2;

function PipelinesV2() {
  const { projectId: workspaceId, isViewOnly } = useOutletContext<{
    projectId: string;
    isViewOnly: boolean;
  }>();

  const [editPipeline, setEditPipeline] = useState(undefined);

  const {
    pipelines,
    isLoading,
    listPipelines,
    createPipeline,
    deletePipeline,
    updatePipeline,
    duplicatePipeline,
  } = usePipelinesV2(workspaceId);

  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (workspaceId) {
      listPipelines();
    }
  }, [workspaceId]);

  const handlePipelineEdit = (pipelineId: string) => {
    setEditPipeline(pipelineId);
  };

  const handlePipelineClick = (pipelineId: string) => {
    navigate({
      pathname: `/pipelines/v2/${pipelineId}`,
      search: location.search,
    });
  };

  return (
    <>
      <div className="max-w-6xl mx-auto flex flex-col flex-1 h-full gap-y-8 px-4 py-8">
        <div className="flex justify-between items-center">
          <Heading>Pipelines V2</Heading>
          <PipelineCreateV2
            onPipelineCreate={createPipeline}
            onPipelineCreated={(pipelineId) => {
              listPipelines(false);
              handlePipelineEdit(pipelineId);
            }}
          />
        </div>
        <div className="flex flex-col flex-1 min-h-0 overflow-auto">
          <PipelineList
            pipelines={pipelines}
            isLoading={isLoading}
            isViewOnly={isViewOnly}
            onPipelineClick={handlePipelineClick}
            onPipelineEdit={handlePipelineEdit}
            onPipelineDelete={deletePipeline}
            onPipelineUpdate={updatePipeline}
            onPipelineDuplicate={duplicatePipeline}
            fetchPipelines={() => listPipelines(false)}
          />
        </div>
      </div>
      {editPipeline && (
        <PipelineBuilderV2
          workspaceId={workspaceId}
          pipelineId={editPipeline}
          onClose={() => setEditPipeline(undefined)}
          onPipelineUpdate={updatePipeline}
        />
      )}
    </>
  );
}
